export enum ContentMediaType {
    Undefined,
    Image,
    AnimatedImage,
    Video
}
